'use es6';

function getRoot(state) {
  return state.collectedForms;
}
export function getCollectedForm(state, guid) {
  return getRoot(state).forms.get(guid);
}
export function getRequestState(state) {
  return getRoot(state).requestState;
}
export function getSubscriptions(state, guid) {
  return getRoot(state).subscriptions.get(guid);
}
export function getSubscriptionsRequestState(state) {
  return getRoot(state).subscriptionsRequestState;
}